import React from 'react'

interface NotInvitedProps {
  email: string
  onRetry: () => void
}

const NotInvited: React.FC<NotInvitedProps> = ({ email, onRetry }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      backgroundColor: '#18181b',
      padding: '20px',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 999
    }}>
      <div style={{
        backgroundColor: '#27272a',
        padding: '40px',
        borderRadius: '12px',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        border: '1px solid #3f3f46',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px'
        }}>
          🔐
        </div>
        
        <h1 style={{
          color: '#3b82f6',
          fontSize: '24px',
          fontWeight: '600',
          margin: '0 0 16px 0',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
          Access Required
        </h1>
        
        <p style={{
          color: '#a1a1aa',
          fontSize: '16px',
          lineHeight: '1.5',
          margin: '0 0 8px 0',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
          Hi there! <strong style={{ color: '#e4e4e7' }}>{email}</strong> doesn't have access yet.
        </p>
        
        <p style={{
          color: '#71717a',
          fontSize: '14px',
          margin: '0 0 24px 0',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
          To get access, email <strong style={{ color: '#3b82f6' }}>Richard@integuru.ai</strong> or try a different email.
        </p>
        
        <button
          onClick={onRetry}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            padding: '12px 16px',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#2563eb'
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = '#3b82f6'
          }}
        >
          Try Different Account
        </button>
      </div>
    </div>
  )
}

export default NotInvited